import { render, staticRenderFns } from "./DynamicRangeReportDetail.vue?vue&type=template&id=10b85f36&scoped=true"
import script from "./DynamicRangeReportDetail.vue?vue&type=script&lang=js"
export * from "./DynamicRangeReportDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicRangeReportDetail.vue?vue&type=style&index=0&id=10b85f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b85f36",
  null
  
)

export default component.exports